import { useContext } from "react";
import { UpdateExperienceCustomContext } from "./UpdateExperienceCustomContext";

const useUpdateExperienceCustomContext = () => useContext(UpdateExperienceCustomContext);

export default useUpdateExperienceCustomContext;
